import { useIntl } from "react-intl";

export const EmptyNextSchedules = () => {
  const intl = useIntl();
  
  return (
    <div>
      <div className="my-8 mx-2">
        {intl.formatMessage({ id: "intl-msg:periodicReviews.nextReviews" })}
      </div>

      <div className="border rounded-lg w-full">
        <div className="text-size-14 text-color-dark border-color-light border-b">
          <div className="p-4">{intl.formatMessage({ id: "intl-msg:periodicReviews.insufficientData" })}</div>
        </div>
        <div className="p-4 text-size-14 text-color-dark">
            <div className="mb-4">{intl.formatMessage({ id: "intl-msg:periodicReviews.cannotDisplayNext" })}</div>
            <div className="mb-4">{intl.formatMessage({ id: "intl-msg:periodicReviews.requiredInfo" })}</div>
            <ul className="mb-4 pl-8">
                <li className="list-disc">{intl.formatMessage({ id: "intl-msg:periodicReviews.vehicleChassis" })}</li>
                <li className="list-disc">{intl.formatMessage({ id: "intl-msg:periodicReviews.maintenanceGroup" })}</li>
                <li className="list-disc">{intl.formatMessage({ id: "intl-msg:periodicReviews.currentOdometer" })}</li>
            </ul>
            <div className="mb-4">{intl.formatMessage({ id: "intl-msg:periodicReviews.verifyData" })}</div>
        </div>

        <div className="flex justify-center items-center p-4">
          <span className="rioglyph rioglyph-cloud-not-saved text-color-lighter" style={{ fontSize: '100px' }} />
        </div>
      </div>
    </div>
  );
};